import { useCallback } from "react";
import ReviewsList from "./ReviewsList";
import { useRouter } from "next/router";

const Reviews = (props) => {
  const { initialReview, profile, reviewFilters, firmOrNetworkType, initialPage, unclaimed } = props;
  const router = useRouter()

  const reviewListRef = useCallback(node => {
    if (!node || !router.query.page) {
      return;
    }

    node.scrollIntoView({ behavior: 'smooth' })
  }, [])

  return (
    <div className='w-full flex flex-wrap box-border mt-16 max-xs:mt-4' id="reviews">
      <div className="grow-0 max-w-full basis-full m-0 box-border">
          <ReviewsList
            initialReviews={initialReview}
            profileName={profile.name}
            profile={profile}
            reviewFilters={reviewFilters}
            reviewsTotalCount={initialReview?.aggregate_data}
            firmOrNetworkType={firmOrNetworkType}
            initialPage={initialPage}
            unclaimed={unclaimed}
            ref={reviewListRef}
          />
      </div>
    </div>
  );
};

export default Reviews;
